import { useMemo } from 'react';
import { getAllVisitorDeliveryIdentifiers } from '../operator/getAllVisitorDeliveryIdentifiers';
import { getSingleAgentDeliveryIdentifier } from '../operator/getSingleAgentDeliveryIdentifier';
import { useThreadDeliveryIdentifierData } from './useThreadDeliveryIdentifierData';
function formatResponse(genericChannelId, threadDeliveryIdentifierData) {
  const threadDeliveryIdentifierDataInChannel = threadDeliveryIdentifierData === null || threadDeliveryIdentifierData === void 0 ? void 0 : threadDeliveryIdentifierData[genericChannelId];
  return {
    threadAgentDeliveryIdentifierData: threadDeliveryIdentifierDataInChannel && getSingleAgentDeliveryIdentifier(threadDeliveryIdentifierDataInChannel),
    threadVisitorDeliveryIdentifiersData: threadDeliveryIdentifierDataInChannel && getAllVisitorDeliveryIdentifiers(threadDeliveryIdentifierDataInChannel)
  };
}
export const useAgentVisitorDeliveryIdentifiers = ({
  threadId,
  genericChannelId,
  onCompleted
}) => {
  const {
    loading,
    error,
    threadDeliveryIdentifierData
  } = useThreadDeliveryIdentifierData({
    threadId,
    onCompleted: onCompleted && (response => {
      onCompleted(formatResponse(genericChannelId, response === null || response === void 0 ? void 0 : response.threadDeliveryIdentifierData));
    })
  });
  const {
    threadAgentDeliveryIdentifierData,
    threadVisitorDeliveryIdentifiersData
  } = useMemo(() => formatResponse(genericChannelId, threadDeliveryIdentifierData), [genericChannelId, threadDeliveryIdentifierData]);
  return {
    loading,
    error,
    threadAgentDeliveryIdentifierData,
    threadVisitorDeliveryIdentifiersData
  };
};